import React from 'react';
import { Table, Button, Card, CardBody, CardHeader } from 'reactstrap';

const InvoiceUploadDetails = ({ partyName, invoiceNum, invoiceDate, items, onDelete, saveInvoice }) => {
    return (
        <Card>
            <CardHeader style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: "12px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "none"
            }}>
                <strong style={{ color: "#fff", fontSize: "16px" }}>
                    <i className="fa fa-file-text" style={{ marginRight: "10px" }}></i>
                    Invoice Details
                </strong>
                <Button color="success" size="sm" onClick={saveInvoice} style={{
                    background: "rgba(255,255,255,0.2)",
                    border: "1px solid rgba(255,255,255,0.3)",
                    color: "#fff",
                    borderRadius: "8px"
                }}>
                    <i className="fa fa-save" /> Save
                </Button>
            </CardHeader>
            <CardBody>
                <div>
                    <p><strong>Party Name:</strong> {partyName}</p>
                    <p><strong>Invoice Number:</strong> {invoiceNum}</p>
                    <p><strong>Invoice Date:</strong> {invoiceDate}</p>
                    <Table bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Serial Number</th>
                                <th>Description</th>
                                <th>HSN</th>
                                <th>MRP</th>
                                <th>Rate</th>
                                <th>Quantity</th>
                                <th>GST Percentage</th>
                                <th>GST Amount</th>
                                <th>Net Amount</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.serialNumber}</td>
                                    <td>{item.description}</td>
                                    <td>{item.hsn}</td>
                                    <td>{item.mrp}</td>
                                    <td>{item.rate}</td>
                                    <td>{item.quantity}</td>
                                    <td>{item.gstPercentage}</td>
                                    <td>{item.gstAmount}</td>
                                    <td>{item.netAmount}</td>
                                    <td>
                                        <Button color="danger" size="sm" onClick={() => onDelete(index)}>
                                            <i className="fa fa-trash" />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default InvoiceUploadDetails;


// WEBPACK FOOTER //
// ./src/components/CustomComponents/InvoiceUploadDetails.js